export const smscRegistrationMutation = (builder) => ({
    smscRegistration: builder.mutation({
      query: (data) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/smsc_registration',
          method: 'POST',
          body: data,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          }
        };
      }
    })
  });
  